<cyno-tabset customClass="tabset tabset--dark">
    <cyno-tab tabTitle="Wel verzekerd" [active]="true">
        <p>U bent wereldwijd verzekerd voor de schade waarvoor u aansprakelijk bent:</p>
        <list-flat icon="check" [svg]="true">
            <list-flat-item>Aan dingen/personen buiten uw gezin</list-flat-item>
            <list-flat-item>Aan personen binnen uw gezin (letsel)</list-flat-item>
            <list-flat-item>Zolang de schade als "particulier" veroorzaakt is</list-flat-item>
        </list-flat>
        <p>Verzekerd is schade veroorzaakt:</p>
        <list-flat icon="check" [svg]="true">
            <list-flat-item>Tijdens een stage/vrijwilligerwerk</list-flat-item>
            <list-flat-item>Brand of waterschade aan een gehuurd vakantieverblijf</list-flat-item>
            <list-flat-item>Door joyriding</list-flat-item>
            <list-flat-item>Terwijl u spullen te leen had</list-flat-item>
            <list-flat-item>Tijdens een vriendendienst</list-flat-item>
            <list-flat-item>Bij letsel aan anderen tijdens sport en spel</list-flat-item>
        </list-flat>
        <p>Wie is verzekerd?</p>
        <list-flat icon="check" [svg]="true">
            <list-flat-item>U en uw gezin</list-flat-item>
            <list-flat-item>Uw huisdieren</list-flat-item>
            <list-flat-item>logés</list-flat-item>
            <list-flat-item>Huispersoneel</list-flat-item>
            <list-flat-item>Uw oppas tijdens het oppassen op uw kinderen</list-flat-item>
        </list-flat>
        <!-- prettier-ignore -->
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat in onze
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                          pdfLinkTitle="Voorwaarden Woonverzekering">voorwaarden</ins-pdf-link>.
        </p>
    </cyno-tab>
    <cyno-tab tabTitle="Niet verzekerd">
        <p>Schade:</p>
        <list-flat icon="dot" [svg]="true">
            <list-flat-item>Ontstaan tijdens (betaald) werk of nevenactiviteit</list-flat-item>
            <list-flat-item>Aan spullen die u huurt, least, pacht of in vruchtgebruik heeft</list-flat-item>
            <list-flat-item>
                Door motorrijtuigen of (lucht)vaartuigen, als daar een rij- of vaarbewijs voor nodig is
            </list-flat-item>
            <list-flat-item>Door (heli)drones/ of grotere modelvliegtuigjes</list-flat-item>
            <list-flat-item>Aan werkspullen die u privé gebruikt (zoals een laptop)</list-flat-item>
        </list-flat>
        <!-- prettier-ignore -->
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat in onze
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                          pdfLinkTitle="Voorwaarden Woonverzekering">voorwaarden</ins-pdf-link>.
        </p>
    </cyno-tab>
    <cyno-tab tabTitle="Eigen Risico">
        <p>Uw eigen risico is €&nbsp;100</p>
    </cyno-tab>
</cyno-tabset>
